var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "600px" },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          $event.preventDefault()
          return _vm.save.apply(null, arguments)
        },
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", [
            _c("span", { staticClass: "headline" }, [_vm._v("Upgrade Config")]),
          ]),
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "4", md: "4" } },
                    [
                      _c("r-item-upgrade-mode", {
                        attrs: { model: _vm.mode },
                        on: {
                          "update:model": function ($event) {
                            _vm.mode = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.mode.id > 0
                    ? _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "3", md: "3" } },
                        [
                          _c("v-text-field", {
                            attrs: { label: "Duration:", "hide-details": "" },
                            model: {
                              value: _vm.model.duration,
                              callback: function ($$v) {
                                _vm.$set(_vm.model, "duration", _vm._n($$v))
                              },
                              expression: "model.duration",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.mode.id > 0
                    ? _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "5", md: "5" } },
                        [
                          _c("r-item-dropdown", {
                            attrs: {
                              model: _vm.model.upgradeItem,
                              label: "Upgrade to:(optional)",
                            },
                            on: {
                              "update:model": function ($event) {
                                return _vm.$set(
                                  _vm.model,
                                  "upgradeItem",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm.mode.id > 0
                ? _c(
                    "v-row",
                    { attrs: { dense: "" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "6", md: "6" } },
                        [
                          _c("r-quest-dropdown", {
                            attrs: {
                              model: _vm.model.questAllow,
                              label: "Quest Allow",
                              clearable: true,
                            },
                            on: {
                              "update:model": function ($event) {
                                return _vm.$set(_vm.model, "questAllow", $event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm.mode.id === 1
                        ? _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "6", md: "6" } },
                            [
                              _c("r-ad-placement-dropdown", {
                                attrs: {
                                  model: _vm.model.adPlacement,
                                  title: "Ad Placement",
                                  "hide-details": "",
                                },
                                on: {
                                  "update:model": function ($event) {
                                    return _vm.$set(
                                      _vm.model,
                                      "adPlacement",
                                      $event
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.mode.id === 1
                ? _c(
                    "v-row",
                    { staticClass: "mt-3", attrs: { dense: "" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "12", md: "12" } },
                        [
                          _c("r-currency-table", {
                            attrs: { items: _vm.model.price, title: "Price" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm.mode.id === 2
                ? _c(
                    "v-row",
                    { staticClass: "mt-3", attrs: { dense: "" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "12", md: "12" } },
                        [
                          _c("r-item-upgrade-rule-table", {
                            attrs: { items: _vm.model.rules, title: "Rules" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm.mode.id === 3
                ? _c(
                    "v-row",
                    { staticClass: "mt-3", attrs: { dense: "" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "12", md: "12" } },
                        [
                          _c("r-item-upgrade-rule-table", {
                            attrs: { items: _vm.model.rules, title: "Rules" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.cancel },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.save },
                },
                [_vm._v("Save")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }